module.exports = __webpack_public_path__ + "static/media/PICTOS_IRIS_APPLICATION.49078302.png";